import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "radio" }
const _hoisted_4 = ["value", "onChange"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "block-item"
}
const _hoisted_7 = { class: "radio" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "block__body vertical"
}
const _hoisted_10 = { class: "block-list vertical" }
const _hoisted_11 = { class: "block-item" }
const _hoisted_12 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "block-desc",
      style: {"margin-bottom":"0"},
      innerHTML: _ctx.text
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["block-body", _ctx.verticalLayout ? 'vertical' : 'horizontal'])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answerChunk, (answer, index) => {
        return (_openBlock(), _createElementBlock("ul", {
          key: answer,
          class: _normalizeClass(["block-list", {
          vertical: _ctx.verticalLayout,
          horizontal: !_ctx.verticalLayout,
          center: answer.length === _ctx.centerNum,
        }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answer, (choiceItem) => {
            return (_openBlock(), _createElementBlock("li", {
              key: choiceItem.order,
              class: "block-item"
            }, [
              _createElementVNode("label", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  value: choiceItem,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.radio) = $event)),
                  type: "radio",
                  class: "radio__input",
                  onChange: ($event: any) => (_ctx.handleSelection(choiceItem))
                }, null, 40, _hoisted_4), [
                  [_vModelRadio, _ctx.radio]
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "radio__shape" }, null, -1)),
                _createElementVNode("p", {
                  class: "radio__title",
                  innerHTML: 
                _ctx.currentLang === 'RU' ? choiceItem.choiceRu : choiceItem.choiceKk
              
                }, null, 8, _hoisted_5)
              ])
            ]))
          }), 128)),
          (index === _ctx.answerChunk.length - 1 && _ctx.customAnswer === true)
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    value: "customAnswer",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.radio) = $event)),
                    type: "radio",
                    class: "radio__input",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSelection('customAnswer')))
                  }, null, 544), [
                    [_vModelRadio, _ctx.radio]
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "radio__shape" }, null, -1)),
                  _createElementVNode("p", {
                    class: "radio__title",
                    innerHTML: 
                _ctx.customTextAnswer !== null
                  ? _ctx.customTextAnswer
                  : _ctx.currentLang === 'RU'
                  ? 'Свой вариант ответа'
                  : 'Сіздің жауап нұсқаңыз'
              
                  }, null, 8, _hoisted_8)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ], 2),
    (_ctx.radio === 'customAnswer')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customAnswerS) = $event)),
                placeholder: 
              _ctx.currentLang === 'RU' ? 'Ваш ответ' : 'Сіздің жауабыңыз'
            ,
                onFocusout: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitCustomAnswer && _ctx.submitCustomAnswer(...args))),
                class: "input",
                style: {"margin":"8px 0 8px 0"}
              }, null, 40, _hoisted_12), [
                [_vModelText, _ctx.customAnswerS]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}